import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as FilerrsSelectors from '../../../selectors/filerrs';

import './style.scss';

const FileInfo = ({ sizeWithUnits, name }) => (
    <span className="file-info-base">
        <span className="file-name" title={name}>{name}</span>
        <span className="file-size" title={sizeWithUnits}>({sizeWithUnits})</span>
    </span>
);

FileInfo.propTypes = {
    sizeWithUnits: PropTypes.string,
    name: PropTypes.string
};

const mapStateToProps = (state, { filerrId }) => ({
    sizeWithUnits: FilerrsSelectors.getFileSizeWithUnitsById(state, filerrId),
    name: FilerrsSelectors.getFileNameById(state, filerrId)
});

export default connect(mapStateToProps)(FileInfo);
